module.exports = __webpack_public_path__ + "img/rijkswaterstaat_logo.2dfea0b9.png";